import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useEditorWebsocket } from "@hooks";
import { Button } from "@components";
import { CircularProgress, Grid } from "@material-ui/core";
import { Stop } from "@assets";
import useStyle from "./AiGeneratorProgress.style";

export const AiGeneratorProgress = () => {
  const { t } = useTranslation();
  const socket = useEditorWebsocket();
  const classes = useStyle();
  
  const [isStopping, setIsStopping] = useState(false);
  
  const handleAiGeneratorStop = () => {
    if(isStopping)
      return;
    setIsStopping(true);
    socket?.requestAiGeneratorStop?.();
  }
  
  return (
    <Grid
      item container
      alignItems="center"
      className={classes.root}
    >
      <h3 className="transparent-3">
        {t("views.editor.ai_gen_progress")}
      </h3>
      <Button
        className="ml-4"
        onClick={handleAiGeneratorStop}
        icon={
          isStopping ? (
            <CircularProgress
              aria-label="progress indicator"
              size={20}
              color="inherit"
            />
          ) : <Stop />
        }
      >
        {t("views.editor.stop_ai_gen")}
      </Button>
    </Grid>
  )
}